import request from '@/sheep/request';

const BannerApi = {
  // 获取Banner列表
  getBannerList: (position) => {
    return request({
      url: '/operation/banner/list',
      method: 'GET',
      params: {
        position,
      },
      custom: {
        isToken: false, // 不需要登录
        showError: false,
        showLoading: false,
      },
    });
  },
};

export default BannerApi;